import React, { useState, useEffect, useRef} from "react";
import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, AreaChart, Area } from "recharts";
import { FaPhoneAlt, FaCalendarAlt,  } from "react-icons/fa";
import { FiRepeat } from "react-icons/fi";
import { MdPhoneCallback, MdRefresh, } from "react-icons/md";
import { IoBanSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { LayoutDashboard, PhoneCall } from "lucide-react";
import CallHistory from "./CallHistory/Callhistory";
import { BellIcon } from "@heroicons/react/24/solid";
import GaugeChart from "react-gauge-chart";


const Dashrigmo = ({ setView, user }) => {
  const [data, setData] = useState({
    totalCalls: 0,
    successfulTransfers: 0,
    callbackSuggested: 0,
    dncList: 0,
    positiveCalls: 0,
  });

  const getStartOfMonth = () => {
    const now = new Date();
    return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1))
      .toISOString()
      .split("T")[0];
  };
  const [loading, setLoading] = useState(true);
  const [fromDate, setFromDate] = useState(getStartOfMonth());
  const [toDate, setToDate] = useState("");
  const [search, setSearch] = useState("");
  const [rawData, setRawData] = useState({
    calls: [],
    callbacks: [],
    dnc: [],
    positiveCalls: [],
  });

  const [histogramData, setHistogramData] = useState([]);

  const today = new Date();
  const last30Days = new Date();
  last30Days.setDate(today.getDate() - 30);


   const [startDate, setStartDate] = useState(last30Days);
    const [endDate, setEndDate] = useState(today);
    const [tempStart, setTempStart] = useState(startDate);
    const [tempEnd, setTempEnd] = useState(endDate);
    const [isOpen, setIsOpen] = useState(false);
    const datePickerRef = useRef(null);
    const filterDropdownRef = useRef(null);
    const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);
    const [activeView, setActiveView] = useState("");
    const [notifications, setNotifications] = useState(["Test notification!"]);
    const [showDropdown, setShowDropdown] = useState(false);
    const gradientColors = ["#4A90E2", "#B3D4FC"];

    const formattedDateRange = startDate && endDate
    ? `${startDate.toLocaleDateString("en-US", { month: "short", day: "2-digit" })} - 
       ${endDate.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" })}`
    : "Select Date Range";

    // const formattedDateRange =
    // startDate && endDate
    //   ? startDate.toDateString() === endDate.toDateString()
    //     ? `${startDate.toLocaleDateString("en-US", { month: "short", day: "2-digit",  })}`
    //     ? `${startDate.toLocaleDateString("en-US", { month: "short", day: "2-digit" })} - 
    //      :  ${endDate.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" })}`
    //   : "Select Date Range";

    // const applyDateRange = () => {
    //   setStartDate(tempStart || startDate);
    //   setEndDate(tempEnd || tempStart || startDate);
    //   setIsOpen(false);
    //   filterData(); 
    //   prepareHistogramData(); 
    // };

    const applyDateRange = () => {
      let newStart = tempStart || startDate;
      let newEnd = tempEnd;
  
      if (!newEnd && newStart) {
        newEnd = new Date(today);
      }
  
      setStartDate(newStart);
      setEndDate(newEnd || today); 
      setTempStart(newStart);
      setTempEnd(newEnd);
      setIsOpen(false);
      filterData();
      prepareHistogramData();
    };

    const handleViewChange = (view) => {
          setActiveView(view);
    };

    const handleClearNotifications = () => {
        setNotifications([]);
        setShowDropdown(false);
      };
    
      // const handleRefresh = () => {
      //   console.log("handleRefresh triggered - reloading page");
      //   setLoading(true); // Start spinning
      //   window.location.reload(); // Reload the page
      // };

      const handleRefresh = () => {
        console.log("handleRefresh triggered - refreshing data");
        setLoading(true);
        const newStart = new Date();
        newStart.setDate(today.getDate() - 30);
        const newEnd = new Date(today);
    
        setStartDate(newStart);
        setEndDate(newEnd);
        setTempStart(newStart);
        setTempEnd(newEnd);
    
        setData({
          totalCalls: 0,
          successfulTransfers: 0,
          callbackSuggested: 0,
          dncList: 0,
          positiveCalls: 0,
        });
        setRawData({
          calls: [],
          callbacks: [],
          dnc: [],
          positiveCalls: [],
        });
        setHistogramData([]);
    
        fetchData();
      };

      useEffect(() => {
        const handleClickOutside = (event) => {
          if (datePickerRef.current && !datePickerRef.current.contains(event.target)) {
            setIsOpen(false);
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
      }, []);

  const navigate = useNavigate();

  useEffect(() => {
    console.log("useEffect triggered. User:", user);
    if (!user) {
      console.log("User is null, skipping fetchData");
      return;
    }
    fetchData();
  }, [user]);

  useEffect(() => {
    filterData();
    prepareHistogramData();
  }, [startDate, endDate, rawData]);


  const fetchData = async () => {
    setLoading(true);
    try {
      const totalCallsData = await (await fetch(`${process.env.REACT_APP_SERVER_API}/api/call-history?userId=${user.id}&role=${user.role}`)).json();
      const callbackData = await (await fetch(`${process.env.REACT_APP_SERVER_API}/api/waiting-list?userId=${user.id}&role=${user.role}`)).json();
      const dncData = await (await fetch(`${process.env.REACT_APP_SERVER_API}/api/dnd-list?userId=${user.id}&role=${user.role}`)).json();
      const positiveCallCountResponse = await fetch(
        `${process.env.REACT_APP_SERVER_API}/api/positive-calls/positivecall-count?userId=${user.id}&role=${user.role}`
      );
      const positiveCallCountData = await positiveCallCountResponse.json();

      setRawData({
        calls: totalCallsData || [],
        callbacks: callbackData || [],
        dnc: dncData || [],
        positiveCalls: positiveCallCountData.success ? positiveCallCountData.data || [] : [],
      });
    } catch (error) {
      console.error("Fetch error:", error);
      setRawData({
        calls: [],
        callbacks: [],
        dnc: [],
        positiveCalls: [],
      });
      setNotifications((prev) => [...prev, `Failed to load data: ${error.message}`]);
    } finally {
      setLoading(false);
    }
  };

  const filterData = () => {
    const from = new Date(startDate);
    from.setHours(0, 0, 0, 0); 
    const to = new Date(endDate);
    to.setHours(23, 59, 59, 999);

    const filteredCalls = rawData.calls.filter((call) => {
      const callDate = new Date(call.createdAt);
      return callDate >= from && callDate <= to;
    });

    const filteredCallbacks = rawData.callbacks.filter((item) => {
      const itemDate = new Date(item.createdAt);
      return itemDate >= from && itemDate <= to;
    });

    const filteredDnc = rawData.dnc.filter((item) => {
      const itemDate = new Date(item.createdAt);
      return itemDate >= from && itemDate <= to;
    });

    const filteredPositiveCalls = rawData.positiveCalls.filter((call) => {
      const callDate = new Date(call.createdAt);
      return callDate >= from && callDate <= to;
    });

    setData({
      totalCalls: filteredCalls.length || 0,
      successfulTransfers: filteredPositiveCalls.length || 0,
      callbackSuggested: filteredCallbacks.length || 0,
      dncList: filteredDnc.length || 0,
      positiveCalls: filteredPositiveCalls.length || 0,
    });
  };


const prepareHistogramData = () => {
  const today = new Date(); 
  today.setHours(23, 59, 59, 999);

  const from = new Date(today);
  from.setDate(today.getDate() - 7);
  from.setHours(0, 0, 0, 0);

  const normalizedCalls = rawData.calls
    .filter((call) => {
      const callDate = new Date(call.createdAt);
      if (isNaN(callDate.getTime())) {
        console.warn("Invalid date found in createdAt:", call.createdAt);
        return false;
      }
      return callDate >= from && callDate <= today;
    })
    .map((call) => ({
      ...call,
      normalizedSentiment: (call.agentSentiment?.toLowerCase().trim() || "") === ""
        ? "not attended"
        : call.agentSentiment.toLowerCase().trim(),
    }));

  const filteredCalls = normalizedCalls.filter((call) =>
    ["positive", "negative", "not attended"].includes(call.normalizedSentiment)
  );

  const dateSequence = [];
  for (let i = 7; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(today.getDate() - i);
    dateSequence.push(date);
  }

  const histogramData = dateSequence.map((date) => {
    const dateStr = date.toISOString().split("T")[0];
    const callsOnDate = filteredCalls.filter(
      (call) => new Date(call.createdAt).toISOString().split("T")[0] === dateStr
    );
    return {
      date: date.toLocaleDateString("en-US", { month: "short", day: "numeric" }),
      positive: callsOnDate.filter((c) => c.normalizedSentiment === "positive").length,
      negative: callsOnDate.filter((c) => c.normalizedSentiment === "negative").length,
      notAttended: callsOnDate.filter((c) => c.normalizedSentiment === "not attended").length,
    };
  });

  console.log("Generated Date Sequence:", dateSequence.map((d) => d.toISOString().split("T")[0]));
  console.log("Histogram Data:", histogramData);

  setHistogramData(histogramData);
};
  
  const COLORS = {
    totalCalls: "#82f63b",
    successfulTransfers: "#f6af3b",
    callbackSuggested: "#df52a7",
    dncList: "#f63b82",
  };

  const dataPie = [
    { name: "Positive Calls", value: data.positiveCalls, color: COLORS.totalCalls },
    { name: "Successful Transfers", value: data.successfulTransfers, color: COLORS.successfulTransfers },
    { name: "Callback Suggested", value: data.callbackSuggested, color: COLORS.callbackSuggested },
    { name: "DNC List", value: data.dncList, color: COLORS.dncList },
  ].filter(item => item.value > 0);
  
  const totalCalls = dataPie.reduce((sum, entry) => sum + entry.value, 0);
  const dataWithPercentage = dataPie.map((entry) => ({
    ...entry,
    percentage: ((entry.value / totalCalls) * 100).toFixed(2) + "%",
  }));

  const renderCustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor="middle"
        dominantBaseline="central"
        className="text-sm font-semibold"
      >
        {percent > 0 ? `${(percent * 100).toFixed(1)}%` : ""}
      </text>
    );
  };

  const dataBar = [
    { category: "Total Calls", count: data.totalCalls, color: COLORS.totalCalls },
    { category: "Successful Transfers", count: data.successfulTransfers, color: COLORS.successfulTransfers },
    { category: "Callback Suggested", count: data.callbackSuggested, color: COLORS.callbackSuggested },
    { category: "DNC List", count: data.dncList, color: COLORS.dncList },
  ].filter(item => item.count > 0);

  const handleTotalCallsClick = () => setView("CallHistory");
  const handleDncCallsClick = () => setView("DoNotDisturb");
  const handleCallbackClick = () => setView("WaitingList");

  const Gauge = ({ value, max = 100 }) => {
    const percentage = (value / max) * 180;
    return (
      <div className="relative w-48 h-24 mx-auto">
        <div className="absolute w-full h-full bg-gray-200 rounded-t-full overflow-hidden">
          <div
            className="absolute w-full h-full bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500"
            style={{
              clipPath: "inset(0 0 50% 0)",
              transform: `rotate(${percentage}deg)`,
              transformOrigin: "center bottom",
            }}
          />
        </div>
        <div className="absolute w-full h-full flex items-end justify-center">
          <div className="text-2xl font-bold text-gray-900">{value}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="flex min-h-screen overflow-y-auto bg-white-100">
      {/* Main Content */}
      <div className="flex-1 p-4 md:p-6 lg:p-8" >
        <div className="flex justify-end items-center mb-6">
          <div className="flex space-x-4 items-center" style={{marginRight:'30px', }}>
            <button
              className="p-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-full border border-gray-300 transition"
              onClick={handleRefresh}
              title="Refresh Call History"
              disabled={loading}
            >
              <MdRefresh className={`text-2xl ${loading ? "animate-spin" : ""}`} />
            </button>
            {/* Date Picker Button */}
            <div className="">  {/* removed position relative */}
              <button
                className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg border border-gray-300 text-sm font-medium transition flex items-center space-x-2"
                onClick={() => setIsOpen(!isOpen)}
                type="button"
                aria-haspopup="dialog"
                aria-expanded={isOpen}
              >
                <FaCalendarAlt className="text-gray-600 w-4 h-4" /> 
                <span>{formattedDateRange}</span>
              </button>
              {isOpen && (
                <div
                  className="absolute left-0 mt-2 bg-white border border-gray-300 rounded-lg shadow-lg z-10 p-6"
                  ref={datePickerRef}
                >
                  <DatePicker
                    selected={tempStart}
                    onChange={(dates) => {
                      const [start, end] = dates || [null, null];
                      setTempStart(start);
                      setTempEnd(end);
                      // If only start date is selected, auto-set end date to 30 days later
                      if (start && !end) {
                        setTempEnd(new Date(today));
                      }
                    }}
                    startDate={tempStart}
                    endDate={tempEnd}
                    selectsRange
                    monthsShown={2}
                    inline
                    fixedHeight
                    calendarClassName="custom-calendar"
                  />
                  <div className="flex justify-end mt-3">
                  <button
                    onClick={applyDateRange}
                    className="px-4 py-2 bg-[#9867C5] text-white rounded-md hover:bg-purple-700 transition"
                  >
                    Apply
                  </button>
                </div>
              </div>
              )}
            </div>

            {/* Dashboard and Call History Buttons */}
            <div className="flex space-x-4 items-center">
                <div className="flex space-x-2 bg-gray-100 p-1 rounded-lg border border-gray-300">
                <button
                    className={`px-4 py-2 flex items-center space-x-2 text-gray-700 rounded-lg text-sm font-medium transition ${
                      activeView === "dashboard" ? "bg-gray-300" : "hover:bg-gray-200"
                    }`}
                    onClick={() => handleViewChange("dashboard")}
                  >
                    <LayoutDashboard className="w-5 h-5" />
                    <span>Dashboard View</span>
                  </button>
                  <button
                    className={`px-4 py-2 flex items-center space-x-2 text-gray-700 rounded-lg text-sm font-medium transition ${
                      activeView === "CallHistory" ? "bg-gray-300" : "hover:bg-gray-200"
                    }`}
                    onClick={() => setView("CallHistory")}
                  >
                    <PhoneCall className="w-5 h-5" />
                    <span>Call History</span>
                  </button>
                  {activeView === "CallHistory" && <CallHistory />}
              </div>
            </div>
            </div>
              <div className="relative text-gray-500" style={{marginLeft:'30px', }}>
                  <div
                    className="relative cursor-pointer hover:text-blue-600 transition duration-300"
                    onClick={() => setShowDropdown(!showDropdown)}
                  >
                    <BellIcon className="h-6 w-6" style={{color:'blue'}}/>
                    {notifications.length > 0 && (
                      <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full px-1">
                        {notifications.length}
                      </span>
                    )}
                  </div>
          
                  {/* Notification Dropdown */}
                  {showDropdown && (
                    <div className="absolute right-0 mt-2 w-64 bg-white border rounded-lg shadow-lg p-4 z-10">
                      {notifications.length > 0 ? (
                        <div>
                          <div className="flex justify-between items-center mb-2">
                            <span className="text-sm font-bold text-gray-700">Notifications</span>
                            <button
                              className="text-xs text-blue-500 hover:underline"
                              onClick={handleClearNotifications}
                            >
                              Clear All
                            </button>
                          </div>
                          <ul className="space-y-2">
                            {notifications.map((notification, index) => (
                              <li
                                key={index}
                                className="text-sm text-gray-600 bg-gray-100 p-2 rounded-md hover:bg-gray-200 transition"
                              >
                                {notification}
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : (
                        <div className="text-sm text-gray-500">No new notifications</div>
                      )}
                    </div>
                  )}
                </div>
          </div>

        {/* Summary Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
          {[
            { icon: <FaPhoneAlt className="text-3xl" style={{ color: "green" }} />, label: "Dialed Calls", value: data.totalCalls, onClick: handleTotalCallsClick },
            { icon: <FiRepeat className="text-3xl" style={{ color: "blue"}} />, label: "Call Transferred", value: data.successfulTransfers },
            { icon: <MdPhoneCallback className="text-3xl" style={{ color: "red" }} />, label: "Callback Suggested", value: data.callbackSuggested, onClick: handleCallbackClick },
            { icon: <IoBanSharp className="text-3xl" style={{ color: "orange" }} />, label: "DNC List", value: data.dncList, onClick: handleDncCallsClick },
          ].map((item, index) => (
            <div
              key={index}
              className={`p-6 bg-gray-100 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 ${item.onClick ? "cursor-pointer hover:bg-gray-50" : ""}`}
              onClick={item.onClick || null}
            >
              <div className="flex justify-between items-center w-full" >
                <div className="flex-1">
                  <p className="text-sm font-medium text-gray-600">{item.label}</p>
                  <p className="text-2xl font-bold text-gray-900">{item.value}</p>
                </div>
                <div className="flex justify-end w-12">
                  {item.icon}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div style={{display:'flex', }}>
            {/* Charts */}
            <div className=" grid-cols-1 lg:grid-cols-2 gap-6 p4" style={{width:'70%', padding:'10px',}}>
              {/* Histogram */}
              <div className="bg-gray-100 p-6 rounded-xl shadow-md">
                  <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">Call Volume</h3>
                  <div className="flex flex-col md:flex-row items-center">
                    <ResponsiveContainer width="100%" height={300} margin={{ top: 5, right: 5, left: 0, bottom: 5 }}>
                      <AreaChart data={histogramData}>
                          <XAxis dataKey="date" stroke="#6B7280" tickFormatter={(value) => value} type="category" />
                          <YAxis stroke="#6B7280" />
                          <Tooltip contentStyle={{ borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }} />
                          <Area type="monotone" dataKey="value" stroke="#a855f7" fill="#f3e8ff" fillOpacity={0.8}  />
                          <Area type="monotone" dataKey="positive" stroke="#a855f7" fill="#f3e8ff" name="Positive" />
                          <Area type="monotone" dataKey="negative" stroke="#a855f7" fill="#f3e8ff" name="Negative" />
                          <Area type="monotone" dataKey="notAttended" stroke="#a855f7" fill="#f3e8ff" name="Not Attended" />
                      </AreaChart>
                    </ResponsiveContainer>
                  </div>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                {/* Pie Chart */}
                <div className="bg-gray-100 p-4 rounded-xl shadow-md">
                  <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">Call Performance Distribution</h3>
                    <div className="flex flex-col md:flex-row items-center">
                      {/* Pie Chart */}
                      <div className="flex-1">
                        <ResponsiveContainer width="100%" height={300}>
                          <PieChart>
                            <Pie
                              data={dataPie}
                              dataKey="value"
                              cx="50%"
                              cy="50%"
                              outerRadius={120}
                              label={renderCustomLabel}
                              labelLine={false}
                            >
                              {dataPie.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.color} />
                              ))}
                            </Pie>
                            <Tooltip
                              formatter={(value, name) => [`${value} Calls`, name]}
                              contentStyle={{ borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
                            />
                          </PieChart>
                        </ResponsiveContainer>
                      </div>

                      <div className="ml-6">
                        {dataWithPercentage.map((entry, index) => (
                          <div key={index} className="flex items-center space-x-3 mb-2">
                            <div className="w-4 h-4 box-full" style={{ backgroundColor: entry.color }}></div>
                            <span className="text-gray-700 font-medium"> {entry.percentage}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                    {/* Bar Chart */}
                    {/* <div className="bg-gray-100 p-6 rounded-xl shadow-md">
                        <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">
                          Call Performance Metrics
                        </h3>
                        <ResponsiveContainer width="100%" height={300}>
                          <BarChart data={dataBar}>
                            <XAxis dataKey="category" stroke="#6B7280" />
                            <YAxis stroke="#6B7280" />
                            <Tooltip
                              formatter={(value, name) => [`${value} Calls`, name]}
                              contentStyle={{
                                borderRadius: "8px",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                              }}
                            />
                            <Bar dataKey="count" radius={[6, 6, 0, 0]} barSize={40}>
                              {dataBar.map((entry, index) => (
                                <Cell
                                  key={`cell-${index}`}
                                  fill={`url(#colorGradient-${index})`} 
                                />
                              ))}
                            </Bar>
                            <defs>
                              {dataBar.map((entry, index) => (
                                <linearGradient key={index} id={`colorGradient-${index}`} x1="0" y1="0" x2="0" y2="1">
                                  <stop offset="0%" stopColor={gradientColors[0]} stopOpacity={1} />
                                  <stop offset="100%" stopColor={gradientColors[1]} stopOpacity={0.6} />
                                </linearGradient>
                              ))}
                            </defs>
                          </BarChart>
                        </ResponsiveContainer>
                      </div> */}

                  {/* Gauge */}
                  <div className="bg-gray-100 p-2 rounded-xl shadow-md">
                    <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">
                      Conversion
                    </h3>
                    <GaugeChart
                      id="positive-calls-gauge"
                      nrOfLevels={20}
                      percent={data.positiveCalls / 100}
                      colors={["#FFA500", "#FF4500"]}
                      arcWidth={0.3}
                      hideText
                      needleColor="#444"
                      needleBaseColor="#444"
                    />
                    <p className="text-center text-xl font-semibold text-gray-800 mt-2">{data.positiveCalls.toFixed(2)}%</p>
                  </div>
              </div>
            </div>

            <div className="border border-gray-200 rounded-lg shadow w-64 overflow-hidden bg-gray-100 mt-3 h-[780px]" style={{width:'30%', padding:'10px', }}>
              <div className="bg-blue-400 p-4 rounded-lg text-white font-semibold text-left mr-4 ml-4 text-xl">
                Live Agents
              </div>
              <ul className="p-4 space-y-2 bg-gray-100">
                <li className="flex justify-between p-3 border-b border-gray-300">
                  <span>Agent James</span>
                  <span className="text-green-600 font-semibold">Online</span>
                </li>
                <li className="flex justify-between p-3 border-b border-gray-200">
                  <span>Agent David</span>
                  <span className="text-red-600 font-semibold">Offline</span>
                </li>
                <li className="flex justify-between p-3 border-b border-gray-200">
                  <span>Agent Bond</span>
                  <span className="text-green-600 font-semibold">Online</span>
                </li>
                <li className="flex justify-between p-3 border-b border-gray-200">
                  <span>Agent Jim</span>
                  <span className="text-red-600 font-semibold">Offline</span>
                </li>
                <li className="flex justify-between p-3 border-b border-gray-200">
                  <span>Agent dot</span>
                  <span className="text-red-600 font-semibold">Offline</span>
                </li>
              </ul>
            </div>
        </div>
      </div>
    </div>
  );
};

export default Dashrigmo;